import { InjectionToken } from '@angular/core';
import { DateTime } from 'luxon';
import { LocalStorageService } from './local-storage.service';

export const MEMORY_CACHE_SERVICE = new InjectionToken<CacheService>(
  'MemoryCache'
);

declare type StorageType = 'localstorage' | 'memory';

/**
 * Cache 服務
 *
 * @export
 * @class CacheService
 */
export class CacheService {
  memoryStorage = new Map<string, CacheItem>();

  constructor(
    private localStorageService: LocalStorageService,
    private lifetime: number = 24 * 60,
    private storage: StorageType = 'memory'
  ) {}

  /**
   * 加入 Cache
   *
   * @param {string} key
   * @param {*} value
   * @memberof CacheService
   */
  add(key: string, value: any): void {
    const pool = this.getCachePool();

    const expiration = DateTime.now()
      .plus({ minute: this.lifetime })
      .toMillis();
    const item: CacheItem = { value, expiration };

    pool.set(key, item);
    this.saveCachePool(pool);
  }

  /**
   * 取得 Cache 資料
   *
   * @param {string} key
   * @return {*}  {void}
   * @memberof CacheService
   */
  get<T>(key: string): T {
    const pool = this.getCachePool();
    const item = pool.get(key);
    return item?.value;
  }

  private saveCachePool(pool: Map<string, CacheItem>): void {
    this.storage === 'memory'
      ? (this.memoryStorage = pool)
      : this.localStorageService.setItem(
          'cachePool',
          Array.from(pool.entries())
        );
  }

  private getCachePool(): Map<string, CacheItem> {
    const pool =
      this.storage === 'memory'
        ? this.memoryStorage
        : new Map<string, CacheItem>(
            this.localStorageService.getItem('cachePool')
          ) ?? new Map<string, CacheItem>();

    const now = DateTime.now().toMillis();
    for (const key of pool.keys()) {
      const cacheItem = pool.get(key) as CacheItem;
      if (cacheItem.expiration <= now) {
        pool.delete(key);
      }
    }

    return pool;
  }
}

interface CacheItem {
  value: any;
  expiration: number;
}
